<template>
  <div class="wp_cartImage_header2">
  <span
    class="wp_cartIconSpan"
    id="header-drop-2"
    aria-expanded="false"
    @click="$router.push({
    path :'/cart',
      query: {
      display_text: 'My Cart',
      }
      })"
				data-test="cartButtonSpan"
  >
      <!-- <img class="icon_cnt" src="@/assets/svg/ei-cart.svg" alt srcset id="cart-img"> -->
      <svg xmlns:xlink="http://www.w3.org/1999/xlink"
           version="1.1"
           id="Capa_1"
           class="wp_SVGCart"
           xmlns="http://www.w3.org/2000/svg"
           x="0px"
           y="0px"
           viewBox="0 0 510 510"
           style="enable-background:new 0 0 510 510;"
           xml:space="preserve"
											data-test="cartButtonSvg"
      >
        <g>
          <g id="shopping-cart">
            <path d="M153,408c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S181.05,408,153,408z M0,0v51h51l91.8,193.8L107.1,306
              c-2.55,7.65-5.1,17.85-5.1,25.5c0,28.05,22.95,51,51,51h306v-51H163.2c-2.55,0-5.1-2.55-5.1-5.1v-2.551l22.95-43.35h188.7
              c20.4,0,35.7-10.2,43.35-25.5L504.9,89.25c5.1-5.1,5.1-7.65,5.1-12.75c0-15.3-10.2-25.5-25.5-25.5H107.1L84.15,0H0z M408,408
              c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51S436.05,408,408,408z"/>
          </g>
        </g>
      </svg>

    <!-- <span class="d-none d-md-block" id="cart-img-span">CART</span> -->
  </span>
  <span class="cart-n wp_cartCountContainer"
            id="cart-count"
            v-show="getCartCount > 0"
								data-test="cartButtonCartCount"
      >
        {{getCartCount}}
      </span>
      </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('cart', ['getCartCount'])
	}
}
</script>

<style>

</style>
